import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';

import ListTableBody from '../../../components/list-table-body/list-table-body.componenet';
import ListHeader from '../../../components/list-header/list-header.component';

import { HELP_ONBOARDING_STEPS_COLUMNS } from './help-onboarding-steps-columns.data';
import { setListType, setLoadedData, setPagePath } from '../../../redux/list/list.actions';
import { setFilterEmpty } from '../../../redux/filter/filter.actions';
import { selectListType } from '../../../redux/list/list.reselect';
import { setIsEditByFullForm } from '../../../redux/form/form.actions';
import { setTabTitle } from '../../../utils/tab-title.utils';
import { selectAccessRights } from '../../../redux/user/user.reselect';

const APP_NAME = `helponboardingstep`;

const TYPE = {
    HELP_ONBOARDING_STEPS: "HELP_ONBOARDING_STEPS",
}

const HelpOnboardingStepsList = ({
    setListType,
    setLoadedData,
    setFilterEmpty,
    listType,
    history,
    setIsEditByFullForm,
    setPagePath,
    accessRights
}) => {
    const [confrimLoadedData, setConfirmLoadedData] = useState(false);
    const [isAccessRightChecked, setIsAccessRightCheked] = useState(false);
    const isViewOnly = useRef(false);

    const endpoint = "/helponboardingsteps";
    const pagePath = "/help-onboarding-steps";

    const handleAddItem = () => {
        history.push(`${pagePath}/new`);
    }

    useEffect(() => {
        const accessRight = accessRights.find((accessRight => {
            return accessRight.application.toLowerCase() === APP_NAME && APP_NAME.toLowerCase()
        }))

        if (accessRight && (accessRight.permission.toLowerCase() === "view only")) {
            isViewOnly.current = true;
        }

        setIsAccessRightCheked(true)
    }, [])

    useEffect(() => {
        if (listType !== TYPE.HELP_ONBOARDING_STEPS) {
            setLoadedData({ data: null, skip: null, totalNumItems: 0 });
            setFilterEmpty();
        }

        setListType(TYPE.HELP_ONBOARDING_STEPS);
        setPagePath(pagePath);
        setIsEditByFullForm(true);
        setConfirmLoadedData(true);
    }, [])

    useEffect(() => {
        return () => {
            setIsEditByFullForm(false);
            setPagePath(null);
        }
    }, [])

    useEffect(() => {
        setTabTitle(`Getting Started Steps`)
    }, [])

    return (
        confrimLoadedData &&
        <>
            <ListHeader
                buttonAction={handleAddItem}
                buttonActionLabel={"Add Step"}
                endpoint={endpoint}
                title={"Getting Started Steps"}
                isViewOnly={isViewOnly.current}
            />
            <ListTableBody
                tableColumns={HELP_ONBOARDING_STEPS_COLUMNS}
                localFilterFields={[]}
                endpoint={endpoint}
            />
        </>
    )
};

const mapStateToProps = createStructuredSelector({
    listType: selectListType,
    accessRights: selectAccessRights
})

const mapDispatchToProps = (dispatch) => ({
    setListType: (listType) =>
        dispatch(setListType(listType)),
    setLoadedData: (data) =>
        dispatch(setLoadedData(data)),
    setFilterEmpty: () =>
        dispatch(setFilterEmpty()),
    setIsEditByFullForm: (data) =>
        dispatch(setIsEditByFullForm(data)),
    setPagePath: (data) =>
        dispatch(setPagePath(data))
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HelpOnboardingStepsList))
